import { useState } from "react";
import ElementosDeProteccionForm from "./ElementosDeProteccionForm";


const initialValues = {
  idElementoDeProteccion: "",
}

const ElementosDeProteccionFormContainer = ({ open, handleClose, handleSubmit, selectedOptions }) => {

  const [formInitialValues, setFormInitialValues] = useState(initialValues);


  return (
    <>
      <ElementosDeProteccionForm
        open={open}
        handleClose={handleClose}
        handleSubmit={handleSubmit}
        initialValues={formInitialValues}
        selectedOptions={selectedOptions}
      />
    </>
  )
}

export default ElementosDeProteccionFormContainer;